import React from "react";
import {
  AiFillFacebook,
  AiFillInstagram,
  AiFillYoutube,
  AiOutlineTwitter,
} from "react-icons/ai";
import { Link } from "react-router-dom";
import { categoriesData } from "../../static/data";


const Footer = () => {
  return (
    <div className="bg-[#222222] text-white">
     
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:px-8 px-5 py-16 sm:text-center">
        <ul className="px-5 text-center sm:text-start flex sm:block flex-col items-center">
          <br />
          <p>All Your industrial needs</p>
          <div className="flex items-center mt-[15px]">
            <AiFillFacebook size={25} className="cursor-pointer" />
            <AiOutlineTwitter
              size={25}
              style={{ marginLeft: "15px", cursor: "pointer" }}
            />
            <AiFillInstagram
              size={25}
              style={{ marginLeft: "15px", cursor: "pointer" }}
            />
            <AiFillYoutube
              size={25}
              style={{ marginLeft: "15px", cursor: "pointer" }}
            />
          </div>
        </ul>

        <ul className="text-center sm:text-start">
          <h1 className="mb-1 font-semibold">Categories</h1>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-1">
            {categoriesData.slice(0, categoriesData.length / 2).map((category, index) => (
              <li key={index}>
                <Link
                  className="text-gray-400 hover:text-teal-400 duration-300
                     text-sm cursor-pointer leading-6"
                  to={`/products?category=${category.title}`}
                >
                  {category.title}
                </Link>
              </li>
            ))}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-1">
            {categoriesData.slice(categoriesData.length / 2).map((category, index) => (
              <li key={index}>
                <Link
                  className="text-gray-400 hover:text-teal-400 duration-300
                     text-sm cursor-pointer leading-6"
                  to={`/products?category=${category.title}`}
                >
                  {category.title}
                </Link>
              </li>
            ))}
          </div>
        </ul>

        <ul className="text-center sm:text-start">
          <h1 className="mb-1 font-semibold">Support</h1>
          <li>
            <Link
              className="text-gray-400 hover:text-teal-400 duration-300
                 text-sm cursor-pointer leading-6"
              to="/contact"
            >
              Contact Us
            </Link>
          </li>
        </ul>
      </div>

      
       <div
  className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10
         text-center pt-2 text-gray-400 text-sm pb-8"
>
  <span>© HAWLER INDUSTRIAL SOLUTIONS PRIVATE LIMITED 2024. All rights reserved.</span>
  <span>
    <Link
      to="/faq?section=terms"
      className="text-gray-400 hover:text-teal-400 mx-2"
    >
      Terms
    </Link>
    ·
    <Link
      to="/faq?section=privacy"
      className="text-gray-400 hover:text-teal-400 mx-2"
    >
      Privacy Policy
    </Link>
    ·
    <Link
      to="/faq?section=shipping"
      className="text-gray-400 hover:text-teal-400 mx-2"
    >
      Shipping
    </Link>
  </span>
</div>       
      </div>
    
  );
};

export default Footer;

